module.exports = __webpack_public_path__ + "img/6@3x.e852b9f2.png";